import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative w-full h-[600px] md:h-[700px] lg:h-[800px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=North%20sea%20coast%20landscape%20with%20green%20dike%20meadows%2C%20sheep%20grazing%2C%20wide%20blue%20sky%20with%20soft%20clouds%2C%20mudflats%20in%20distance%2C%20warm%20natural%20beige%20and%20green%20color%20palette%2C%20editorial%20landscape%20photography%2C%20serene%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=hero-nordsee-01&orientation=landscape"
        alt="Nordseeküste Dornumersiel"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <span className="inline-block px-4 py-1.5 mb-6 text-xs md:text-sm font-medium tracking-widest uppercase bg-accent-500/90 text-white rounded-full">
          {t('about.badge')}
        </span>
        <h1 className="font-heading text-4xl md:text-5xl lg:text-7xl font-bold text-white max-w-4xl leading-tight">
          {t('hero.title')}
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-xl text-white/85 max-w-2xl leading-relaxed">
          {t('hero.subtitle')}
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => scrollTo('booking')}
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('hero.ctaPrimary')}
          </button>
          <button
            onClick={() => scrollTo('about')}
            className="px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white text-sm font-semibold rounded-md backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer border border-white/30"
          >
            {t('hero.ctaSecondary')}
          </button>
        </div>
      </div>
    </section>
  );
}